<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title aling="center">Usuarios</v-toolbar-title>
      </v-toolbar>
      <v-card flat>
        <v-btn absolute dark fab top right color="success" @click="dialog = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-card-text>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-data-table
            :headers="headers"
            :items="datos"
            :items-per-page="5"
            class="elevation-1"
            :search="search"
          >
            <template v-slot:item.imagen="{ item }">
              <v-avatar size="32">
                <img :src="item.imagen_usuario.length > 10 ? item.imagen_usuario : api+'uploads/default-user-image.png'" alt="img">
              </v-avatar>
            </template>
                      
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-card>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field v-model="editedItem.nombres" label="Nombres" required outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="editedItem.apellidos" label="Apellidos" required outlined></v-text-field>
              </v-col>              
              <v-col cols="12">
                <v-text-field v-model="editedItem.correo" label="Usuario" required outlined></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select :items="niveles" v-model="editedItem.level" label="Nivel de Usuario" outlined></v-select>
              </v-col>
              <v-col cols="12">
                <v-autocomplete v-model="editedItem.institucion" :items="instituciones" outlined label="Institución" ></v-autocomplete>
                
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn color="blue darken-1" text @click="restablecer">Reiniciar Clave</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import swal from "sweetalert";
import api from "../conf/ruta-base";
import store from "../store";
export default {
  name: "instituciones",
  data: () => ({
    apiPath: "user",
    search: "",
    dialog: false,
    headers: [
      { text: "Imagen", value: "imagen" },
      { text: "Nombre", align: "start", sortable: true, value: "nombres" },
      { text: "Usuario", value: "correo" },
      { text: "Nivel", value: "level" },
      { text: "Institución", value: "inst.nombre" },
      { text: "Acciones", value: "actions", sortable: false }
    ],
    datos: [],
    selec: '',
    niveles: [
        {text:'Administrador Institucional',value:'adm'},
        {text:'Supra Administrador',value:'sys'}, 
        ],
    instituciones:[],
    editedIndex: -1,
    editedItem: {
      id: "",
      nombres: "",
      imagen: "",
      correo: "",
      direccion: "",
      institucion: ""
    },
    defaultItem: {
      id: "",
      nombres: "",
      imagen: "",
      correo: "",
      direccion: "",
      institucion: ""
    }
  }),
  mounted() {
    axios
      .get(api.api + this.apiPath + '/inst')
      .then(r => {
        let i = 0;
        for (i = 0; i < r.data.length; i++) {
          r.data[i].institucion = parseInt(r.data[i].institucion)
          this.datos.push(r.data[i]);
        }
      })
      .catch(error => {
        console.log(error);
      });
    //Nos traemos el arreglo de las instituciones
    axios
      .get(api.api + 'institucion')
      .then(r => {
        let i = 0;
        for (i = 0; i < r.data.length; i++) {
          this.instituciones.push({
              text:r.data[i].nombre,
              value:r.data[i].id
            });
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Usuario" : "Modificar Usuario";
    }
  },
  methods: {

    editItem(item) {
      this.editedIndex = this.datos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    presave(){
      let bandera = true
      let err = ''
        if(bandera && this.editedItem.nombres.length == 0){
          bandera = false
          err = 'Debe ingresarlos nombres.'
        }

        if(bandera && this.editedItem.apellidos.length == 0){
          bandera = false
          err = 'Debe especificar los apellidos'
        }
  
        if(bandera && this.editedItem.correo.length == 0){
          bandera = false
          err = 'Ingrese el correo'
        }

        if(bandera && this.editedItem.level.length == 0){
          bandera = false
          err = 'Ingrese el nivel'
        }

        if(bandera && this.editedItem.institucion.length == 0){
          bandera = false
          err = 'Ingrese la institucion'
        }
      if(bandera){
        this.save()
      }else{
        swal('',err,'error');
      }
      
    },

    save() {
      if (this.editedIndex > -1) {
        let index = this.editedIndex
        Object.assign(this.datos[this.editedIndex], this.editedItem)
        axios
          .put(api.api + this.apiPath + '/supra', this.editedItem)
          .then(res => {
            this.datos[index].inst.nombre = res.data.inst.nombre
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.editedItem.api = api.api
        axios
          .post(api.api + this.apiPath + '/supra', this.editedItem)
          .then(res => {
            res.data.institucion = parseInt(res.data.institucion)
            this.datos.push(res.data);
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      }
      this.close();
    },
    
    deleteItem (item) {
      const index = this.datos.indexOf(item)
      swal({text: "¿Seguro que desea eliminar?",icon: "warning", buttons: ["Cancelar", "Ok"],})
      .then(ok => {
        if(ok){
          axios.delete(api.api + this.apiPath, {data: item})
          .then(res => {
            if(res.data.c=='success'){
              this.datos.splice(index, 1)
            }
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
        }
      })
    },
    
    restablecer(){
      axios
          .put(api.api + 'user/reset/' + this.editedItem.id, this.editedItem)
          .then(res => {
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      this.close()
    },

    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    }
  }
};
</script>